import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatTime } from 'app/core/shared/helper/time.helper';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AprService } from 'app/modules/annulus-pressure-record/services/annulus-pressure-record.service';
import { combineDateTime } from 'app/core/shared/helper/date.helper';
import module from "app/modules/annulus-pressure-record/annulus-pressure-record.module";

@Component({
  selector: 'app-apr-create',
  templateUrl: './apr-create.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./apr-create.component.scss']
})
export class AprCreatePage {
  public aprForm: FormGroup
  public initialFormValues: any;

  public aprRecord: any
  private aprId = this.route.snapshot.paramMap.get('id');

  ngOnInit() {
    this.aprForm = this.initializeForm()

    this.getApr()
  }

  constructor(
    private fb: FormBuilder,
    public location: Location,
    private route: ActivatedRoute,
    private aprService: AprService,
    private router: Router,
  ) { }

  initializeForm() {
    return this.fb.group({
      wellStringId: '',//this.data.wellStringId,
      wellStringName: [{ value: '', disabled: true }],
      activity: [{ value: '', disabled: true }],
      thp: 0,
      annAPress: 0,
      annBPress: 0,
      annCPress: 0,
      annDPress: 0,
      annATemp: 0,
      annBTemp: 0,
      annCTemp: 0,
      annDTemp: 0,
      remarks: '',
      recordDate: new Date().toISOString(),
      recordTime: formatTime(new Date)
    })
  }

  private getApr() {
    this.aprService.getAprRecord(this.aprId).subscribe((res) => {
      if (res) {
         this.aprRecord = res.data

        this.aprForm.patchValue({
          wellStringId: this.aprRecord.wellStringId,
          wellStringName: this.aprRecord.stringShortName,
          activity: this.aprRecord.activity
        })

        this.initialFormValues = { ...this.aprForm.getRawValue() }
      }
    })
  }

  createApr() {
    let recordDate = this.aprForm.get('recordDate').value

    if (typeof recordDate === 'object' && recordDate !== null) {
      let date = new Date()
      date.setDate(recordDate.get('day'))
      date.setMonth(recordDate.get('month') - 1)
      date.setFullYear(recordDate.get('year'))

      this.aprForm.patchValue({ recordDate: date.toISOString() })
    }

    const combinedDateTime = combineDateTime(this.aprForm.get('recordDate').value, this.aprForm.get('recordTime').value)
    this.aprForm.patchValue({ recordDate: combinedDateTime })

    this.aprService.createAprecords(this.aprForm.getRawValue()).subscribe((res) => {
      if (res) {
        this.back()
      }
    })
  }

  hasFormChanged(): boolean {
    return JSON.stringify(this.initialFormValues) !== JSON.stringify(this.aprForm.getRawValue());
  }

  back(){
    this.router.navigate(
      [`/data-management/annulus-pressure-record/`],
      { queryParams: { tab : this.aprRecord.activity} }
    );
  }
}
